import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {AccountantMonitorModel} from "@services/back-office/model/accountantMonitorModel";
import {AccountantMonitorRequest} from "@services/back-office/model/accountantMonitorRequest";
import {AccountantMonitorActions, AccountantMonitorActionTypes} from "@crm/ngrx/actions/accountant-monitor.actions";
import {PaginationModel} from "@shared/models/pagination.model";
import {ConfigService} from "@config/config.service";

export const adapter: EntityAdapter<AccountantMonitorModel> = createEntityAdapter<AccountantMonitorModel>({
    selectId: (item: AccountantMonitorModel) => item.organization!.id!
});

export interface State extends EntityState<AccountantMonitorModel> {
    loading: boolean,
    pagination: PaginationModel,
    filter: AccountantMonitorRequest
}

export const initialState: State = adapter.getInitialState( {
    loading: false,
    pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 0,
        size: new ConfigService().paginationConfig.pageSize,
        totalElements: 0,
    },
    filter: {}
});

export function reducer(state = initialState, action: AccountantMonitorActions): State {
    switch (action.type) {
        case AccountantMonitorActionTypes.LoadAccountantMonitor:
            return {...state, loading: !action.payload?.dontShowLoading};

        case AccountantMonitorActionTypes.LoadAccountantMonitorSuccess:
            return adapter.setAll(action.payload.content!, {
                ...state,
                loading: false,
                pagination: {
                    size: action.payload.size,
                    last: action.payload.last,
                    totalElements: action.payload.totalElements,
                    numberOfElements: action.payload.numberOfElements,
                    first: action.payload.first,
                    number: action.payload.number,
                },
            });

        /** Change Page */
        case AccountantMonitorActionTypes.ChangePage:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    number: action.payload.number,
                    size: action.payload.size,
                }
            };

        /** Set Initial Pagination */
        case AccountantMonitorActionTypes.SetInitialPagination:
            return {...state, pagination: initialState.pagination};

        case AccountantMonitorActionTypes.LoadAccountantMonitorFailure:
            return {...state, loading: false};

        /** Set Filter */
        case AccountantMonitorActionTypes.SetFilter:
            return {...state, filter: action.payload};

        /** Clear Filter */
        case AccountantMonitorActionTypes.ClearFilter:
            return {...state, filter: initialState.filter};

        /** Set Initial State */
        case AccountantMonitorActionTypes.SetInitialState:
            return {...initialState};

        default:
            return state;
    }
}

export const {
    selectAll: selectAllAccountantMonitor
} = adapter.getSelectors();
